module.exports = __webpack_public_path__ + "static/media/blue.a34f25fe.png";